var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-app":""}},[_c('ParameterList',{attrs:{"parameters":_vm.parameters,"getParametros":_vm.getParametros}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }